import React, { FunctionComponent, memo } from "react";
import { Flex } from "@chakra-ui/react";
import { isEqual } from "lodash";

import { PlcMetric, PlcSourceTarget } from "../types";

import SourcePrimaryMetric from "./SourcePrimaryMetric";
import { useIntl } from "react-intl";


interface IProps{
  value: PlcMetric;
  target?: PlcSourceTarget;
  outOfBounds?: boolean;
}


const SourcePower: FunctionComponent<IProps> = memo(function SourcePower({
  value,
  target,
  outOfBounds,
}) {
  const intl = useIntl();

  return <>
    <Flex
      flexDirection="column"
    >
      {target?.kw_control_power ? (
        <>
          <SourcePrimaryMetric
            name={intl.formatMessage({
              id: "site__control__control_power",
              defaultMessage: "Control power target",
            })}
            unit="kW"
            value={target?.kw_control_power}
            drift={target?.kw_control_power_drift}
            outOfBounds={outOfBounds}
          />
        </>
      ) : (
        <>
          <SourcePrimaryMetric
            name={intl.formatMessage({
              id: "site__control__active_power",
              defaultMessage: "Active power",
            })}
            unit="kW"
            value={value && value[1] as number}
          />
        </>
      )}
    </Flex>
  </>
}, isEqual);

export default SourcePower;
